import AXIOS from "./axios";

export class Banks {
  static fetch() {
    return AXIOS.get("/gateway_payments/banks");
  }
}
